import React from 'react';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'medium', 
  color = '#4a90e2' 
}) => {
  const getSize = () => {
    switch (size) {
      case 'small':
        return '24px';
      case 'large':
        return '64px';
      default:
        return '40px';
    }
  };

  const spinnerSize = getSize();

  return (
    <div 
      className="loading-spinner-container" 
      style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        width: '100%',
        padding: '20px 0'
      }}
    >
      <div 
        className="loading-spinner" 
        style={{
          width: spinnerSize,
          height: spinnerSize,
          border: `4px solid rgba(0, 0, 0, 0.1)`,
          borderTopColor: color,
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}
      />
      <style dangerouslySetInnerHTML={{__html: `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}} />
    </div>
  );
};

export default LoadingSpinner;
